<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-datepicker
            :range="true"
            defaultStart="-1M"
            defaultEnd="0M"
            label="기간"
            name="period"
            v-model="searchParam.period"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            type="search"
            :comboItems="stepItems"
            itemText="stepperMstNm"
            itemValue="stepperMstCd"
            name="sopFireFightingPermitStepCd"
            label="진행단계"
            v-model="searchParam.sopFireFightingPermitStepCd"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="소방 공사 목록"
      :columns="grid.columns"
      :data="grid.data"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'fireFightingPermit',
  data() {
    return {
      searchParam: {
        plantCd: null,
        period: [],
        sopFireFightingPermitStepCd: null,
      },
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: 'LBLPLANT',
            align: 'center',
            sortable: true,
            style: 'width: 100px',
          },
          {
            name: 'permitNo',
            field: 'permitNo',
            label: '허가번호',
            align: 'center',
            sortable: true,
            style: 'width: 90px',
            type: 'link'
          },
          {
            name: 'workSummary',
            field: 'workSummary',
            label: '작업개요',
            align: 'left',
            sortable: true,
            style: 'width: 250px',
            type: 'link'
          },
          {
            name: 'permitDt',
            field: 'permitDt',
            label: '작업일시',
            align: 'center',
            sortable: true,
            style: 'width: 150px',
          },
          {
            name: 'workManagerName',
            field: 'workManagerName',
            label: '작업책임자',
            align: 'center',
            sortable: true,
            style: 'width: 100px',
          },
          {
            name: 'confirmDate',
            field: 'confirmDate',
            label: '확인일',
            align: 'center',
            sortable: true,
            style: 'width: 100px',
          },
          {
            name: 'sopFireFightingPermitStepName',
            field: 'sopFireFightingPermitStepName',
            label: '진행상태',
            align: 'center',
            sortable: true,
            style: 'width: 100px',
          },
        ],
        data: [],
      },
      stepItems: [],
      editable: true,
      listUrl: '',
      popupOptions: {
        isFull: false,
        width: '80%',
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.fft.fireFightingPermit.list.url
      // code setting
      this.$comm.getStepItems('SOP_FIRE_FIGHTING_PERMIT_STEP_CD').then(_result => {
        this.stepItems = this.$_.concat([{
          stepperMstNm: '미확인',
          stepperMstCd: 'NONE',
        }], _result)
      });
      
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row, col) {
      if (col.name === 'workSummary') {
        this.popupOptions.title = '소방 공사 상세';
        this.popupOptions.param = {
          sopWorkPermitId: row ? row.sopWorkPermitId : '',
        };
        this.popupOptions.target = () => import(`${'./fireFightingPermitDetail.vue'}`);
        this.popupOptions.width = '80%';
        this.popupOptions.isFull = false;
      } else {
        this.popupOptions.title = '작업허가서 상세';
        this.popupOptions.param = {
          sopWorkPermitId: row ? row.sopWorkPermitId : '',
          permitTypeCd: 'SPT0000001',
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/swp/safeWorkPermitDetail.vue'}`);
        this.popupOptions.width = '100%';
        this.popupOptions.isFull = true;
      }
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
